import { pagination } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './algolia-create-instance';

function initPaginationWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaData.localized;

  // Get all elements with refinement list class
  const elements = document.querySelectorAll("[data-filter-type='pagination']")
  const elementsArray = Array.from(elements);

  // Group together refinement list elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {
        const widgetID = element.getAttribute('data-id');
        const indexName = element.getAttribute('data-index')
        const showFirst = tgblAlgoliaData[widgetID]['show_first']
        const showPrevious = tgblAlgoliaData[widgetID]['show_previous']
        const showNext = tgblAlgoliaData[widgetID]['show_next']
        const showLast = tgblAlgoliaData[widgetID]['show_last']
        const paginationPadding = tgblAlgoliaData[widgetID]['padding']
        const hitsPerPage = tgblAlgoliaData[widgetID]['hits_per_page']
        
        const search = getInstance(indexName)
        search.once('render', () => {
          const configureState = search.renderState[indexName]?.configure;
          if (configureState) {
            configureState.refine({
              hitsPerPage: hitsPerPage,
            });
          }
        });

        let AlgoliaPagination = ($, search, element) => {
          search.addWidgets([
            pagination({
              container: element,
              showFirst: showFirst, 
              showPrevious: showPrevious, 
              showNext: showNext, 
              showLast: showLast, 
              padding: paginationPadding, 
              // totalPages: element.getAttribute('data-total-pages'),
              cssClasses: {
                root: 'tgblAlgolia-pagination',
                list: 'tgblAlgolia-pagination__controls',
                item: 'tgblAlgolia-pagination__controls__item',
                link: 'tgblAlgolia-pagination__controls__item__link',
                disabledItem: 'tgblAlgolia-pagination__controls__item--disabled',
                selectedItem: 'tgblAlgolia-pagination__controls__item--active',
              },
            })
          ]);
          registerWidget(element);
        };
        AlgoliaPagination($, search, element);
      });
    }
  }
}

export { initPaginationWidget }


